// extracted by mini-css-extract-plugin
export default {"Wrapper":"load-failure-modal_Wrapper__Ufxlr","Title":"load-failure-modal_Title__aikHM","P":"load-failure-modal_P__XWQKD"};